export default function Footer() {
  return (
    <footer style={{ background: "linear-gradient(180deg, #0d2b5e 0%, #0a1628 100%)" }} className="text-gray-300 py-14">
      <div className="max-w-5xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-10">
          <div className="md:col-span-1">
            <img
              src="https://aisprint.jp/assets/img/logo_header_ja.svg"
              alt="PRI AI Sprint"
              className="h-8 mb-4 brightness-0 invert"
            />
            <p className="text-xs text-blue-200/70 leading-relaxed">
              株式会社ピーアールアイは、生成AIを活用したAI開発により企業のDX推進を加速します。「動くアプリ」を最短1週間でお届けし、貴社のビジネスを前進させます。
            </p>
          </div>
          <div>
            <h4 className="text-sm font-bold text-white mb-4"><a href="#packages" className="text-white hover:text-white cursor-pointer">サービス</a></h4>
            <ul className="space-y-2">
              {[
                { label: "パッケージS(特別価格50万円・製造業特化)", href: "#packages" },
                { label: "パッケージA(100万円)", href: "#packages" },
                { label: "パッケージB(200万円)", href: "#packages" },
                { label: "無料相談", href: "#contact" },
              ].map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-xs text-blue-200/70 hover:text-white transition-colors cursor-pointer">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-bold text-white mb-4"><a href="https://pr-i.co.jp/" target="_blank" rel="noopener noreferrer nofollow" className="text-white hover:text-white cursor-pointer">会社情報</a></h4>
            <ul className="space-y-2">
              {[
                { label: "会社概要", href: "https://pr-i.co.jp/" },
                { label: "プライバシーポリシー", href: "https://pr-i.co.jp/privacy/" },
                { label: "特定商取引法に基づく表記", href: "https://pr-i.co.jp/%e7%89%b9%e5%ae%9a%e5%95%86%e5%8f%96%e5%bc%95%e6%b3%95%e3%81%ab%e5%9f%ba%e3%81%a5%e3%81%8f%e8%a1%a8%e8%a8%98/" },
              ].map((l) => (
                <li key={l.label}>
                  <a href={l.href} target="_blank" rel="noopener noreferrer nofollow" className="text-xs text-blue-200/70 hover:text-white transition-colors cursor-pointer">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-bold text-white mb-4"><a href="#contact" className="text-white hover:text-white cursor-pointer">お問い合わせ</a></h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://pr-i.co.jp/contact/"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="text-xs text-blue-200/70 hover:text-white transition-colors cursor-pointer"
                >
                  お問い合わせフォーム
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-blue-800/50 pt-6 text-center">
          <p className="text-xs text-blue-200/50">Copyright &copy; 株式会社ピーアールアイ All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}
